import { Tooltip } from "../arc/components/tooltip/tooltip";
import styles from "./RouteSuggestion.module.css";

/**
 * Best outreach route, shown wherever a rep might spend AI credits.
 * Rules-based (no credits). Built on Arc Tooltip + Arc tokens.
 * variant="chip" (briefing cards) | "banner" (outreach pane, shows reason)
 */
export default function RouteSuggestion({ suggestion, variant = "chip" }) {
  const rec = suggestion?.recommended;
  if (!rec) return null;

  if (variant === "banner") {
    return (
      <div className={styles.banner} role="note">
        <span className={styles.label}>Best route: {rec.label}</span>
        <span className={styles.reason}>{rec.reason}</span>
      </div>
    );
  }

  return (
    <Tooltip content={rec.reason} side="top">
      <span className={styles.chip} tabIndex={0}>
        Best route: {rec.label}
      </span>
    </Tooltip>
  );
}
